// extracted by mini-css-extract-plugin
export default {"linkColor":"a3R7l","external":"b3R7l","quote":"c3R7l","listMarkdown":"d3R7l"};